import React, { useEffect, useState } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';

const MOBILE_MQ = '(max-width: 767px)';

export function useAskAiMobileFullscreen(open: boolean) {
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
  ));
  const [fullscreen, setFullscreen] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
  ));

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const sync = () => {
      setIsMobile(mq.matches);
      setFullscreen(mq.matches);
    };
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (!open && isMobile) setFullscreen(true);
  }, [open, isMobile]);

  const mobileFullscreen = Boolean(open && fullscreen && isMobile);
  const mobileCompact = Boolean(open && isMobile && !fullscreen);

  useEffect(() => {
    if (!open || !isMobile) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open, isMobile]);

  return {
    mobileFullscreen,
    mobileCompact,
    toggleFullscreen: () => setFullscreen((value) => !value),
  };
}

export function AskAiMobileScrim({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) {
  if (!show) return null;
  return (
    <button
      type="button"
      className="md:hidden fixed inset-0 z-[1090] bg-black/40 pointer-events-auto border-0 p-0 cursor-pointer"
      aria-label="Dismiss Ask AACore AI"
      onClick={onClose}
    />
  );
}

export function AskAiMobileFullscreenButton({
  fullscreen,
  onToggle,
  textColor,
}: {
  fullscreen: boolean;
  onToggle: () => void;
  textColor: string;
}) {
  const Icon = fullscreen ? Minimize2 : Maximize2;
  return (
    <button
      type="button"
      className="md:hidden w-8 h-8 border bg-transparent flex items-center justify-center cursor-pointer"
      style={{ borderColor: `${textColor}22`, color: textColor, borderRadius: 8 }}
      aria-label={fullscreen ? 'Exit fullscreen chat' : 'Open chat fullscreen'}
      aria-pressed={fullscreen}
      title={fullscreen ? 'Exit fullscreen' : 'Fullscreen'}
      onClick={onToggle}
    >
      <Icon className="w-4 h-4" aria-hidden="true" />
    </button>
  );
}
